import React from 'react';
import { Droplets, ShieldCheck } from 'lucide-react';

export const HeroSection = () => {
  return (
    <section className="py-6 lg:py-8" style={{ backgroundColor: '#FFFFFF' }}>
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-8 items-start">
          {/* Left Column - Content */}
          <div className="space-y-5">

            {/* Headline */}
            <h1 className="text-4xl lg:text-5xl xl:text-6xl font-bold leading-tight tracking-tight text-slate-950">
              <span className="bg-gradient-to-r from-[#0C4288] via-[#1671BA] to-[#2A9AD8] bg-clip-text text-transparent">
                Cleaner
              </span>{" "}
              water for you...
            </h1>

            {/* ── CONVERSION IQ COPY: Hero Subheadline ──────────────────────────────
                 Replace or supplement the paragraph below with Conversion IQ copy.
                 This is the primary value-prop statement visible above the fold.
            ──────────────────────────────────────────────────────────────────────── */}
            {/* Subheadline */}
            <p className="text-lg lg:text-xl leading-relaxed" style={{ color: '#475569' }}>
              Professional water treatment design, sales, installation, and service for Long Island, NYC, Westchester, and South Florida.
            </p>

            {/* ── CONVERSION IQ COPY: Credibility / Trust Statement ─────────────────
                 Replace or supplement the blue box below with Conversion IQ trust copy.
                 Good for certifications, guarantees, or a key differentiator sentence.
            ──────────────────────────────────────────────────────────────────────── */}
            {/* Credibility line */}
            <div className="flex items-start gap-3 p-4 rounded-xl" style={{ backgroundColor: '#E3F2FD' }}>
              <ShieldCheck className="h-6 w-6 flex-shrink-0 mt-0.5" style={{ color: '#1571BA' }} />
              <p className="text-base font-medium" style={{ color: '#0C4288' }}>
                Professionally designed by a Master Water Specialist and installed by a qualified plumber
              </p>
            </div>

            {/* Buttons */}
            {/* ── "Request a Complimentary Water Evaluation" CTA removed per client request ── */}
            <div className="flex">
              <a
                href="#services"
                className="aq-primary-btn inline-block text-center font-bold text-lg px-8 py-4 rounded-lg transform hover:scale-105 shadow-md"
              >
                Our Services
              </a>
            </div>
          </div>

          {/* Right Column - Image */}
          <div className="relative flex justify-center lg:justify-end">
            <div 
              className="relative"
              style={{
                display: 'inline-block',
                width: 'min(100%, 460px)',
                height: 'auto',
                minHeight: '0',
                padding: '0',
                background: 'transparent',
                borderRadius: '28px',
              }}
            >
              <img
                src={`${process.env.PUBLIC_URL}/process_step_2.png`}
                alt="Water treatment equipment"
                style={{
                  display: 'block',
                  width: '100%',
                  height: 'auto',
                  maxWidth: '100%',
                  objectFit: 'initial',
                  borderRadius: 'inherit',
                  boxShadow: '0 18px 40px rgba(15, 35, 60, 0.14)',
                }}
              />

              {/* Floating Badge */}
              <div className="absolute -bottom-6 -left-6 md:bottom-6 md:-left-12 bg-white rounded-2xl shadow-xl p-4 backdrop-blur-sm bg-white/95 z-10">
                <div className="flex items-center gap-3">
                  <div className="p-3 rounded-xl" style={{ backgroundColor: '#E3F2FD' }}>
                    <Droplets className="h-6 w-6" style={{ color: '#1571BA' }} />
                  </div>
                  <div>
                    <p className="font-bold" style={{ color: '#0F172A' }}>Crystal Clear</p>
                    <p className="text-sm" style={{ color: '#1571BA' }}>100% Treated Water</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
